<div class="modal-container main-font">
  <div class="header-container">
    <div class="user-container">
      <img
        [src]="utilityService.getSanitizeUrl(user.path)"
        [alt]="user.first_name"
        class="user-image" />
      <div class="user-info">
        <p class="mb-0 user-name">{{ user.first_name }} {{ user.last_name }}</p>
        <p class="mb-0 user-role">{{ user.role }}</p>
      </div>
    </div>
    <button class="close-modal-btn" (click)="closeModal()">
      <img src="assets/images/icon_calendar/close-modal.svg" alt="close" />
    </button>
  </div>

  <div class="modal-content">
    <div class="calendar-container">
      <!-- Month picker -->
      <div class="month-picker" [attr.data-label]="formattedMonth">
        <button class="btn-month" (click)="previousMonth()">
          <img src="assets/images/icon_calendar/previews.svg" alt="previews" />
        </button>
        <nz-date-picker
          #datePicker
          nzInline
          [(ngModel)]="monthSelected"
          [nzShowToday]="false"></nz-date-picker>
        <button class="btn-month" (click)="nextMonth()">
          <img src="assets/images/icon_calendar/next.svg" alt="next" />
        </button>
      </div>

      <!-- Tabella Mensile -->
      <div class="table-container">
        <!-- Calendario -->
        <div class="table-month">
          <tr class="week-container">
            <th id="day-week" class="day-week">
              <p class="mb-0 text-week">L</p>
            </th>
            <th id="day-week" class="day-week">
              <p class="mb-0 text-week">M</p>
            </th>
            <th id="day-week" class="day-week">
              <p class="mb-0 text-week">M</p>
            </th>
            <th id="day-week" class="day-week">
              <p class="mb-0 text-week">G</p>
            </th>
            <th id="day-week" class="day-week">
              <p class="mb-0 text-week">V</p>
            </th>
          </tr>

          <tr
            class="row-days"
            *ngFor="let week of chunkedDays; let first = first"
            [ngClass]="{ 'border-top': first }">
            <td
              *ngFor="let day of week"
              class="day-container"
              [ngClass]="{
                'bg-weekend': !isInSelectedMonth(day.date)
              }">
              <div class="day">
                <div class="request-container">
                  <img
                    *ngIf="day.is_holiday"
                    src="assets/images/icon_calendar/holiday.svg"
                    alt="holiday"
                    class="icon" />
                  <img
                    *ngFor="let request of day.requests"
                    [src]="getIconRequestUi(request.type).icon"
                    [ngClass]="{
                      pending: request.status === 'pending'
                    }"
                    class="icon" />
                </div>
                <p
                  class="mb-0"
                  [ngClass]="{
                    'text-day-current': isInSelectedMonth(day.date),
                    'text-day-not-current': !isInSelectedMonth(day.date),
                    'text-day-holiday': day.is_holiday
                  }">
                  {{ day.date | date: 'd' }}
                </p>
              </div>
            </td>
          </tr>
        </div>
      </div>
    </div>

    <!-- Leggenda -->
    <div class="legend-container">
      <div class="legend-group" *ngFor="let event of events">
        <img [src]="event.img" alt="" class="legend-icon" />
        <p class="mb-0 text-icon text-icon">{{ event.label }}</p>
      </div>
    </div>
  </div>
</div>
